import {
  BackwardFilled,
  BackwardOutlined,
  DeleteOutlined,
  EditOutlined,
  StarOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Descriptions,
  Form,
  Row,
  Tag,
  Input,
  Avatar,
  Comment,
  List,
  Typography,
  Space,
  Modal,
  Tooltip,
  message,
  Divider,
} from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import reviewApi from "../../api/reviewApi";
import moment from "moment";
import Swal from "sweetalert2";
import { systemActions } from "../../store";
import { useDispatch } from "react-redux";
import config from "../../consts/config";
import AVATAR from "../../assets/images/quan-tri-vien-vnfarm.jpg";

const heart = [
  <svg
    width="22"
    height="22"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.17157 5.17157C4.73367 3.60948 7.26633 3.60948 8.82843 5.17157L10 6.34315L11.1716 5.17157C12.7337 3.60948 15.2663 3.60948 16.8284 5.17157C18.3905 6.73367 18.3905 9.26633 16.8284 10.8284L10 17.6569L3.17157 10.8284C1.60948 9.26633 1.60948 6.73367 3.17157 5.17157Z"
      fill="#fff"
    ></path>
  </svg>,
];
const cart = [
  <svg
    width="22"
    height="22"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2C7.79086 2 6 3.79086 6 6V7H5C4.49046 7 4.06239 7.38314 4.00612 7.88957L3.00612 16.8896C2.97471 17.1723 3.06518 17.455 3.25488 17.6669C3.44458 17.8789 3.71556 18 4 18H16C16.2844 18 16.5554 17.8789 16.7451 17.6669C16.9348 17.455 17.0253 17.1723 16.9939 16.8896L15.9939 7.88957C15.9376 7.38314 15.5096 7 15 7H14V6C14 3.79086 12.2091 2 10 2ZM12 7V6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6V7H12ZM6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10ZM13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9Z"
      fill="#fff"
    ></path>
  </svg>,
];

const { TextArea } = Input;

const CommentList = ({ comments }) => (
  <List
    dataSource={comments}
    header={`${comments.length} trả lời`}
    itemLayout="horizontal"
    // renderItem={(props) => (
    //   <List.Item actions={[<a key="list-loadmore-more">Xóa</a>]}>
    //     <Comment {...props} />
    //   </List.Item>
    // )}
    renderItem={(props) => <Comment {...props} />}
  />
);

const Editor = ({ onChange, onSubmit, submitting, value }) => (
  <>
    <Form.Item>
      <TextArea rows={4} onChange={onChange} value={value} />
    </Form.Item>
    <Form.Item>
      <Button
        htmlType="submit"
        loading={submitting}
        onClick={onSubmit}
        type="primary"
      >
        Thêm nhận xét
      </Button>
    </Form.Item>
  </>
);

const DetailsReview = (props) => {
  const confirm = Modal.confirm;
  const dispatch = useDispatch();

  const { Title, Text } = Typography;
  let { id } = useParams();
  let navigate = useNavigate();
  const goToPreviousPath = () => {
    navigate(-1);
  };

  const back = () => {
    goToPreviousPath();
  };
  const [itemReview, setItemReview] = useState({});

  useEffect(() => {
    getReview(id);
    getReviewParent(id);
  }, []);

  const getReview = (id) => {
    reviewApi.getReview(id).then((res) => {
      if (res) {
        setItemReview(res);
      }
    });
  };
  const setLoading = (status) => {
    dispatch(systemActions.setLoadingSystem(status));
  };

  const [comments, setComments] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [value, setValue] = useState("");

  const handleSubmit = () => {
    if (!value) return;
    setLoading(true);
    setSubmitting(true);
    createReview();
  };

  const getReviewParent = (_id) => {
    const params = {
      parent: _id,
      page: 1,
      limit: 10000,
    };
    reviewApi.getReviews(params).then((res) => {
      if (res?.results) {
        const data = res?.results.map((item) => {
          return {
            actions: [
              <span
                className="span-hover"
                key="comment-list-reply-to-0"
                onClick={() => deleteReviewAdmin(item.id)}
              >
                Xóa
              </span>,
            ],
            author: <b>VNFarm - Quản trị viên</b>,
            avatar: AVATAR,
            content: <p>{item.content}</p>,
            datetime: moment(item.createdAt).fromNow(),
          };
        });

        setComments(data);
      }
      setLoading(false);
    });
  };

  const createReview = () => {
    const payload = {
      customer: null,
      content: value,
      product: itemReview.productId,
      star: 0,
      status: 1,
      isAdmin: true,
      order: null,
      parent: id,
    };
    reviewApi.createReview(payload).then(
      (res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Nhận xét thành công",
            icon: "success",
            confirmButtonText: "OK",
          });
          setValue("");
          setSubmitting(false);
          getReview(id);
          getReviewParent(id);
          setLoading(false);
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Nhận xét thất bại",
            icon: "error",
            confirmButtonText: "OK",
          });
          setSubmitting(false);
          setLoading(false);
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
        setSubmitting(false);
        setLoading(false);
      }
    );
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  const dateFormat = "DD/MM/YYYY HH:mm:ss";

  const ExampleComment = ({ children }) => (
    <Comment
      author={
        <b>{itemReview.customerName ? itemReview.customerName : "Admin"}</b>
      }
      avatar={
        <Avatar
          src={
            itemReview.customerAvatar
              ? config.CDN_URL + itemReview.customerAvatar
              : {AVATAR}
          }
          alt="avatar"
        />
      }
      content={<p>{itemReview.content}</p>}
      datetime={
        <Tooltip title={moment(itemReview.createdAt).format(dateFormat)}>
          <span>{moment(itemReview.createdAt).fromNow()}</span>
        </Tooltip>
      }
    >
      {children}
    </Comment>
  );

  const deleteReview = (_id) => {
    const data = {
      ids: _id,
    };
    confirm({
      title: "Bạn có muốn xóa review này không?",
      onOk() {
        reviewApi
          .deleteReview(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công review ");
              goToPreviousPath();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deleteReviewAdmin = (_id) => {
    const data = {
      ids: _id,
    };
    confirm({
      title: "Bạn có muốn xóa nhận xét này không?",
      onOk() {
        reviewApi
          .deleteReview(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công");
              getReviewParent(id);
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };
  return (
    <>
      <Card
        bordered={false}
        title={<h6 className="font-semibold m-0">Chi tiết đánh giá</h6>}
        extra={
          <>
            <Space>
              <Button
                type="default"
                icon={<BackwardFilled />}
                onClick={() => {
                  back();
                }}
              >
                Quay lại
              </Button>
              <Button
                value="large"
                type="primary"
                icon={<DeleteOutlined />}
                danger
                onClick={() => deleteReview(id)}
              >
                Xóa
              </Button>
            </Space>
          </>
        }
      >
        <div className="layout-content">
          <Row className="rowgap-vbox" gutter={[24, 0]}>
            <Col xs={24} sm={24} md={12} lg={6} xl={6} className="mb-24">
              <Card bordered={false} className="criclebox ">
                <div className="number">
                  <Row align="middle" gutter={[24, 0]}>
                    <Col xs={18}>
                      <span>Sản phẩm</span>
                      <Link to={`/product/edit/` + itemReview.productId}>
                        <Title level={3}>{itemReview.productName}</Title>
                      </Link>
                    </Col>
                    <Col xs={6}>
                      <div className="icon-box">{cart}</div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
            <Col xs={24} sm={24} md={12} lg={6} xl={6} className="mb-24">
              <Card bordered={false} className="criclebox ">
                <div className="number">
                  <Row align="middle" gutter={[24, 0]}>
                    <Col xs={18}>
                      <span>Số sao đánh giá</span>
                      <Title level={3}>{itemReview.star}</Title>
                    </Col>
                    <Col xs={6}>
                      <div className="icon-box">
                        <StarOutlined />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
            <Col xs={24} sm={24} md={12} lg={6} xl={6} className="mb-24">
              <Card bordered={false} className="criclebox ">
                <div className="number">
                  <Row align="middle" gutter={[24, 0]}>
                    <Col xs={18}>
                      <span>Lượt bầu chọn hữu ích</span>
                      <Title level={3}>{itemReview.like}</Title>
                    </Col>
                    <Col xs={6}>
                      <div className="icon-box">{heart}</div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
        <Card>
          <ExampleComment>
            {comments.length > 0 && <CommentList comments={comments} />}
          </ExampleComment>
        </Card>
        <br />
        <Divider />
        <Comment
          avatar={
            <Avatar src="https://joeschmoe.io/api/v1/random" alt="avatar" />
          }
          content={
            <Editor
              onChange={handleChange}
              onSubmit={handleSubmit}
              submitting={submitting}
              value={value}
            />
          }
        />
      </Card>
    </>
  );
};

export default DetailsReview;
